// extracted by mini-css-extract-plugin
export default {"celebrate":"Celebrate-module__celebrate__AH0aNMn","copilotRun":"Celebrate-module__copilotRun__RHD2AHc"};